// ProfileSection.jsx
import "../../../../../design/profileSection.css";
import 'leaflet/dist/leaflet.css';
import { MapContainer, TileLayer, Marker, Popup, useMapEvents, useMap } from "react-leaflet";
import { useEffect, useState } from "react";
import api from "../../../../../api/API_SERVERS";
import { motion } from "framer-motion";

import L from 'leaflet';
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl: markerIcon2x,
    iconUrl: markerIcon,
    shadowUrl: markerShadow,
});

export default function ProfileSection({ formData, setFormData, originalData, setOriginalData, showToast }) {
    const [saving, setSaving] = useState(false);
    const addressChanged = formData.address !== originalData?.address;
    const isLocked = !addressChanged;

    function LocationPicker() {
        useMapEvents({
            click(e) {
                const { lat, lng } = e.latlng;
                setFormData(prev => ({ ...prev, location: [lat, lng] }));
            },
        });
        return null;
    }

    function RecenterMap({ location }) {
        const map = useMap();
        useEffect(() => {
            setTimeout(() => {
                map.invalidateSize();
                map.setView(location);
            }, 200);
        }, [location, map]);
        return null;
    }

    const location = formData?.location?.length === 2
        ? [parseFloat(formData.location[0]), parseFloat(formData.location[1])]
        : [41.7151, 44.8271];

    const isChanged = JSON.stringify({ ...formData, person_id: undefined, fullname: undefined }) !==
        JSON.stringify({ ...originalData, person_id: undefined, fullname: undefined });

    const handleSubmit = async () => {
        try {
            const locationChanged = JSON.stringify(formData.location) !== JSON.stringify(originalData.location);
            if (addressChanged && !locationChanged) {
                return showToast("მისამართის შეცვლისას მონიშნეთ ახალი ლოკაცია რუკაზე 📍");
            }

            let data = {};
            Object.keys(formData).forEach(key => {
                if (formData[key] !== originalData[key]) data[key] = formData[key];
            });
            delete data.person_id;
            delete data.fullname;

            setSaving(true);
            await api.put("/api/teachers/profile/update", data);
            showToast("პროფილი განახლდა ✅", "success");
            setOriginalData(formData);
        } catch (error) {
            showToast(error.response?.data?.message || "შეცდომა ❌");
        } finally {
            setSaving(false);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "mobile_number" && (!/^\d*$/.test(value) || value.length > 9)) return;
        setFormData({ ...formData, [name]: value });
    };

    return (
        <motion.div className="profile-section-container" initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
            <div className={`map-wrapper-glass ${isLocked ? "locked" : ""}`}>
                <MapContainer center={location} zoom={13} className="leaflet-map-cinematic">
                    <TileLayer url="https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png" />
                    {!isLocked && <LocationPicker />}
                    <RecenterMap location={location} />
                    <Marker position={location} draggable={!isLocked}>
                        <Popup>{formData.fullname}<br />{formData.address}</Popup>
                    </Marker>
                </MapContainer>
                {isLocked &&
                    <div className="map-glass-overlay"><span>🔒 მისამართის შეცვლისას რუკა გააქტიურდება</span></div>}
            </div>

            <div className="info-glass-panel">
                <h3 className="panel-title">პირადი ინფორმაცია</h3>
                <div className="input-grid">
                    <div className="glass-input-group">
                        <label>პირადი ნომერი</label>
                        <input value={formData.person_id || ""} disabled className="readonly-input" />
                    </div>
                    <div className="glass-input-group">
                        <label>სახელი და გვარი</label>
                        <input value={formData.fullname || ""} disabled className="readonly-input" />
                    </div>
                    <div className="glass-input-group">
                        <label>ელ-ფოსტა</label>
                        <input name="email" value={formData.email || ""} onChange={handleChange}
                               placeholder="example@mail.com" />
                    </div>
                    <div className="glass-input-group">
                        <label>მობილური</label>
                        <input name="mobile_number" value={formData.mobile_number || ""} onChange={handleChange}
                               placeholder="5XXXXXXXX" />
                    </div>
                    <div className="glass-input-group full-width">
                        <label>მისამართი</label>
                        <input name="address" value={formData.address || ""} onChange={handleChange}
                               placeholder="ქალაქი, ქუჩა, ნომერი" />
                    </div>
                </div>
                <button className={`save-profile-btn ${!isChanged || saving ? "disabled" : ""}`} onClick={handleSubmit}
                        disabled={!isChanged || saving}>
                    {saving ? "პროცესშია..." : "მონაცემების შენახვა"}
                </button>
            </div>
        </motion.div>
    );
}